import { ReactElement } from "react";

import {
  FilterActionsDividerStyled,
  FilterActionsStyled,
} from "@ryde/controls";

import { FiltersApplyReports } from "./apply.reports";
import { FilterAddButtonReports } from "./filter-add-button.reports";
import { FilterClearButtonReports } from "./filter-clear-button.reports";

export const FiltersActionsReport = (): ReactElement => {
  return (
    <FilterActionsStyled>
      <FilterAddButtonReports />
      <FilterActionsDividerStyled />
      <FilterClearButtonReports />
      <FilterActionsDividerStyled />
      <FiltersApplyReports />
    </FilterActionsStyled>
  );
};
